import { Modal } from 'antd';
import styled from 'styled-components';

export const ModalComponentStyle = styled(Modal)`
  .ant-modal-content {
    .ant-modal-close {
      color: #ffffff;
    }
    background-color: #f0f0f0;
    border: 1px solid #745811;
    .ant-modal-header {
      background-color: #0c3255;
      border: none;
      .ant-modal-title {
        color: #ffffff;
      }
    }
    .ant-modal-body {
      .ant-form-item-label {
        label {
          color: #0c3255;
        }
      }
      .button-footer {
        display: flex;
        justify-content: end;
        gap: 5px;
        margin-top: 20px;
      }
    }
  }
`
